import Chart from "react-apexcharts";
import { Skeleton, Typography } from "@mui/material";
import { DashCard } from "./DashCard";
import { colors, fontFamily } from "../../data/tokens";
import { NamedSeries } from "./useDashboardData";

const compactBRL = (v: number) =>
  v >= 1_000_000
    ? `${(v / 1_000_000).toLocaleString("pt-BR", {
        maximumFractionDigits: 1,
      })} mi`
    : v >= 1_000
    ? `${Math.round(v / 1_000).toLocaleString("pt-BR")} mil`
    : String(Math.round(v));
const fullBRL = (v: number) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Receita (R$) por categoria de transação — todo o histórico, só
// receitas (fase 2 dos KPIs, endpoint /transactions/stats/overview)
export function RevenueCategoryChart({
  categories,
}: {
  categories: NamedSeries | null;
}) {
  return (
    <DashCard title="Receita por categoria (R$, histórico)">
      {!categories ? (
        <Skeleton variant="rounded" height={280} />
      ) : categories.labels.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Nenhuma receita registrada.
        </Typography>
      ) : (
        <Chart
          type="bar"
          height={300}
          series={[{ name: "Receita", data: categories.values }]}
          options={{
            chart: { fontFamily, toolbar: { show: false } },
            colors: [colors.success],
            plotOptions: {
              bar: { horizontal: true, borderRadius: 4, barHeight: "55%" },
            },
            dataLabels: { enabled: false },
            xaxis: {
              categories: categories.labels,
              // Barra horizontal: o eixo x é o numérico (Apex pode
              // entregar string — coagir antes de formatar)
              labels: { formatter: (v: any) => compactBRL(Number(v)) },
            },
            // Nomes de categoria são longos ("Receitas de Contribuições",
            // "Ressarcimento de Despesas Prediais") — sem largura extra o
            // Apex trunca os rótulos do eixo
            yaxis: { labels: { maxWidth: 300 } },
            grid: { borderColor: colors.neutral200 },
            tooltip: { y: { formatter: fullBRL } },
          }}
        />
      )}
    </DashCard>
  );
}
